.questionContainer {
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 16px 0;
}

.markers {
    display: flex;
    flex-direction: row;
    gap: 8px;
    flex-wrap: wrap;
}

.filesContainer {
    margin-top: 12px;
}

.filesHeader {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
}

.filesList {
    display: flex;
    flex-direction: column;
    gap: 4px;
}
